import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';
export const dealArray = (arr) => {
    return arr.map((e) => ({
        name: e.name,
        alias: e.originName,
        fieldCode: e.fieldShortName,
        dataType: e.type,
        filedId: e.id,
        ...e?.additional,
    }));
};
export const dealOrderByBoList = (arr) => {
    return arr.map((e) => ({
        name: e.name,
        alias: e.originName,
        fieldCode: e.fieldShortName,
        dataType: e.type,
        sortSymbol: 'DESC',
        filedId: e.id,
        aggregateType: e?.additional?.aggregateType || 'COUNT',
    }));
};
export const dealFieldByList = (arr) => {
    return arr.map((e) => ({
        name: e.name,
        alias: e.originName,
        filedId: e.id,
    }));
};
export const dealSymbol = (val, type) => {
    if (val)
        return val;
    if (type === 'fuzzyQuery') {
        return '匹配';
    }
    else if (type === 'rangeQuery') {
        return '大于,小于';
    }
    else {
        return '等于';
    }
};
const getTypeFunc = (type) => {
    switch (type) {
        case 2:
            return Number;
        default:
            return String;
    }
};
export const formateData = ({ data, fields }) => {
    const clone = JSON.parse(JSON.stringify(data));
    const typeMap = new Map();
    fields.forEach((e) => {
        typeMap.set(e.fieldShortName, getTypeFunc(e.deType));
    });
    clone.forEach((e) => {
        Object.entries((key) => {
            e[key] = typeMap.get(key)(e[key]);
        });
    });
    return clone;
};
export const getCellWidth = (value) => {
    if (value == null) {
        return 10;
    }
    else if (/.*[\u4e00-\u9fa5]+.*$/.test(value)) {
        const chineseLength = value.match(/[\u4e00-\u9fa5]/g).length;
        const otherLength = value.length - chineseLength;
        return chineseLength * 2.1 + otherLength * 1.1;
    }
    else {
        return value.toString().length * 1.1;
    }
};
export const getTextWidth = (text, size = 14) => {
    const font = `${size}px Microsoft YaHei`;
    var span = document.createElement('span');
    span.style.visibility = 'hidden';
    span.style.font = font;
    span.innerHTML = text;
    document.body.appendChild(span);
    var width = span.getBoundingClientRect().width;
    document.body.removeChild(span);
    return width;
};
export const exportExcel = (d, fcols, name = '表格') => {
    let tw = Array.from({ length: fcols.length }).map((_) => []);
    fcols.forEach((e, i) => {
        tw[i].push(getCellWidth(e.title));
    });
    const temp = d.map((e) => {
        const obj = {};
        fcols.forEach((key, i) => {
            obj[key.title] = e[key.dataIndex];
            tw[i].push(getCellWidth(e[key.dataIndex]));
        });
        return obj;
    });
    const mw = tw.map((e) => ({ wch: Math.max(...e) }));
    const ws = XLSX.utils.json_to_sheet(temp);
    ws['!cols'] = mw;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${name}_${new Date().toLocaleString()}.xlsx`, { type: 'binary' });
};
export const downloadFile = (blob, name = '表格') => {
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    const fileName = `${name}_${new Date().toLocaleString()}.xlsx`;
    link.href = blobUrl;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(blobUrl);
};
export function uuid() {
    return ((Math.random() * 1e6) >> 0).toString(36);
}
export function getToken() {
    const TOKEN = 'Admin-Token-Consumer';
    var name = TOKEN + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0)
            return c.substring(name.length, c.length);
    }
    return '';
}
export function generateRules(rules = [], type = 'string') {
    const rs = [];
    rules?.forEach((item) => {
        if (item?.checked && item.type === 'REQUIRED') {
            rs.push({ required: true, message: item?.message || '此项为必填项!' });
        }
        if (item?.checked && item.type === 'MIN') {
            rs.push({
                min: Number(item?.min),
                message: item?.message || `必须大于${item?.min}`,
                type: 'number',
            });
        }
        if (item?.checked && item.type === 'MAX') {
            rs.push({
                max: Number(item?.max),
                message: item?.message || `必须小于${item?.max}`,
                type: 'number',
            });
        }
        if (item?.checked && item.type === 'MINLEN') {
            rs.push({
                min: Number(item?.minlen),
                message: item?.message || `输入长度至少为${item?.minlen}个`,
                type,
            });
        }
        if (item?.checked && item.type === 'MAXLEN') {
            rs.push({
                max: Number(item?.maxlen),
                message: item?.message || `输入长度至多为${item?.maxlen}个`,
                type,
            });
        }
    });
    return rs;
}
export function fIsMobile() {
    return (window.innerWidth < 768 ||
        /Android|iPhone|iPad|iPod|BlackBerry|webOS|Windows Phone|SymbianOS|IEMobile|Opera Mini/i.test(navigator.userAgent));
}
export function dom2image(dom, filename) {
    return new Promise((resolve, reject) => {
        if (dom) {
            try {
                html2canvas(dom).then((canvas) => {
                    const a = document.createElement('a');
                    a.href = canvas.toDataURL();
                    a.target = '_blank';
                    a.download = filename;
                    setTimeout(function () {
                        a.dispatchEvent(new MouseEvent('click'));
                    });
                    resolve('success');
                });
            }
            catch (error) {
                reject();
            }
        }
    });
}
export function getSearchType(type) {
    switch (type) {
        case 'drawerSelect':
            return 'multipleSelect';
        default:
            return type || 'fuzzyQuery';
    }
}
export function formatPercentNumber(num, decimalPlaces = 2) {
    const numtemp = Number(num) * 100;
    if (Number.isInteger(numtemp)) {
        return numtemp.toString() + '%';
    }
    else {
        return numtemp.toFixed(decimalPlaces) + '%';
    }
}
;
